import React, { FC } from 'react';
import styled from 'styled-components';
import SelectListItem from './SelectListItem';

export const SelectListWrapper = styled.div<{ dark: boolean; grid: boolean }>`
  background-color: ${({ dark }) => (dark ? 'var(--colorBlueGray1100)' : 'var(--colorWhite)')};
  border-radius: 8px;
  border: ${({ grid }) => (grid ? 'none' : '1px solid')};
  border-color: ${({ dark }) => (dark ? 'var(--colorBlueGray900)' : 'var(--colorBlueGray200)')};
  display: ${({ grid }) => (grid ? 'grid' : 'block')};
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;

  & > div {
    border-radius: 8px;
    border-bottom: 1px solid;
    border-top: ${({ grid }) => (grid ? '1px solid' : 'none')};
    border-left: ${({ grid }) => (grid ? '1px solid' : 'none')};
    border-right: ${({ grid }) => (grid ? '1px solid' : 'none')};
    border-color: ${({ dark }) => (dark ? 'var(--colorBlueGray900)' : 'var(--colorBlueGray200)')};

    &:last-child {
      border-bottom: ${({ grid }) => (grid ? '1px solid inherit' : 'none')};
    }
  }
`;

export interface ListItem {
  id: string;
  name: string;
  description?: string;
  disabled?: boolean;
}

interface Props {
  list: ListItem[];
  selectedId?: string | null;
  onSelect: (id: string) => void;
  dark?: boolean;
  grid?: boolean;
}

const SelectList: FC<Props> = ({ list, selectedId, onSelect, dark = false, grid = false }) => {
  return (
    <SelectListWrapper dark={dark} grid={grid}>
      {list.map((item) => {
        const isActive = item.id === selectedId;
        return (
          <SelectListItem
            key={item.id}
            id={item.id}
            name={item.name}
            description={item.description}
            disabled={item.disabled}
            active={isActive}
            onSelect={onSelect}
            dark={dark}
          />
        );
      })}
    </SelectListWrapper>
  );
};

export default SelectList;
